const translate = {
    Geo: {
      ContactDetails: 'საკონტაქტო ინფორმაცია',
      NotamiAgency: 'საქართველოს სამოქალაქო ავიაციის სააგენტო',
      Search: 'ძებნა',
      Tbilisi: 'თბილისი',
      Anzor: 'ანზორი ყურაშვილი',
      Natia: 'ნათია ახობაძე',
      Irakli:'ირაკლი ლოლაშვილი',
      Giorgi: 'გიორგი ლომია',
      Dimitri: 'დიმიტრი მახათაძე',
      Batumi: 'ბათუმი',
      Kutaisi: 'ქუთაისი',
      Mestia: 'მესტია',
      Telavi: 'თელავი',
      Ambrolauri: 'ამბროლაური',
      News: 'სიახლეები',
      Home: 'მთავარი',
      AboutUs: 'ჩვენ შესახებ',
      Projects: 'პროექტები',
      Gallery: 'გალერეა',
      Catalog: 'კატალოგი',
      GoBack: 'უკან',
      Pilots: "ლიცენზირებული მფრინავები",
      WeatherOnTheRunways: "ამინდი ასაფრენ ბილიკებზე",
      usefulLinks: "სასარგებლო ლინკები",
      Calendar: 'კალენდარი',
      AirPlane: "თვითმფრინავები",
      Contact: 'კონტაქტი',
      ReadMore: 'ვრცლად',
      Notami: 'ნოტამი',
      wind: 'ქარი',
      speed: 'მ/წმ',
      visibility: 'მხედველობა',
      km : 'კმ',
      AeroClubGeorgia: 'აეროქლაბ ჯეორჯია',
      Abouttext: 'ფადიკო გოგიტიძე პირველი ქართველი მფრინავი ქალია. იგი 1916 წელს ქობულეთში დაიბადა. 1936 წელს დაამთავრა თბილისის საფრენოსნო სკოლა. როგორც გაზეთი “საბჭოთა აჭარა” 1936 წლის აგვისტოს ნომერში წერდა, ფადიკო გოგიტიძეს საფრენოსნო საქმე ერთ წელში უნდა შეესწავლა: „ერთ წელში უნდა დაუფლებოდა მანქანის მართვას. ერთ წელში უნდა გამხდარიყო მფრინავი…'
    },
    Eng: {
      Anzor: 'Anzor Kurashvili',
      Irakli:'Irakli Lolashvili',
      Dimitri: 'Dimitri Makhatadze',
      ContactDetails: 'Contact Details',
      speed: 'm/s',
      visibility: 'Visibility',
      km: 'km',
      NotamiAgency: 'Georgian Civil Aviation Agency',
      Notami: 'Notami',
      Tbilisi: 'Tbilisi',
      Batumi: ' Batumi',
      Kutaisi: 'Kutaisi',
      Mestia: 'Mestia',
      Telavi: 'Telavi',
      Ambrolauri: 'Ambrolauri',
      AeroClubGeorgia: 'AeroClub Georgia',
      Search: 'Search',
      News: 'News',
      Home: 'Home',
      GoBack: 'Go Back',
      ReadMore: 'Read more',
      AboutUs: 'About Us',
      Pilots: "Licensed pilots",
      AirPlane: "Airplanes",
      WeatherOnTheRunways: "Weather On The Runways",
      usefulLinks: "Useful Links",
      Projects: 'Projects',
      Gallery: 'Gallery',
      Catalog: 'Catalog',
      Calendar: 'Calendar',
      Contact: 'Contact',
      wind: 'Wind',
      Giorgi: 'Giorgi Lomia',
      Natia: 'Natia Akhobadze',
      Abouttext: 'Fadiko Gogitidze is the first Georgian woman pilot. He was born in 1916 in Kobuleti. In 1936 he graduated from Tbilisi Flying School. As the newspaper "Soviet Adjara" wrote in the August issue of 1936, Fadiko Gogitidze had to study the flight case in one year: "In one year he had to master driving a car. Must have become a pilot in one year…'
    },
    Rus: {
      AeroClubGeorgia:'Аэроклуб Грузия',
      ContactDetails: 'Контактная информация',
      Dimitri: 'Димитрий Махатадзе',
      speed: 'м/с',
      Anzor: 'Анзор Курашвили',
      Natia: 'Натия Ахобадзе',
      Irakli:'Ираклий Лолашвили',
      Giorgi: 'Георгий Ломиа',
      visibility: 'видимость',
      km: 'Км',
      wind: 'ветер',
      NotamiAgency: 'Агентство гражданской авиации Грузии',
      Notami: 'Нoтам',
      Tbilisi: 'Тбилиси',
      Batumi: 'Батуми',
      Kutaisi: 'Кутаиси',
      Mestia: 'Местия',
      Telavi: 'Телави',
      Ambrolauri: 'Амбролаури',
      Search: 'Поиск',
      News: 'Новости',
      Home: 'Домой',
      AboutUs: 'насчет нас',
      Projects: 'Проекты',
      Gallery: 'Галерея',
      AirPlane: "Самолеты",
      GoBack: 'назад',
      ReadMore:'Читать далее',
      WeatherOnTheRunways: "Погода на полосах",
      usefulLinks: "Полезная ссылка",
      Catalog: 'Каталог',
      Calendar: 'Календарь',
      Pilots: "Лицензированные пилоты",
      Contact: 'Связаться с нами',
      Abouttext: 'Фадико Гогитидзе - первая грузинка-пилот. Он родился в 1916 году в Кобулети. В 1936 году окончил Тбилисское летное училище. Как писала газета «Советская Аджария» в августовском номере 1936 года, Фадико Гогитидзе должен был изучить случай полета за один год: «За год он должен был освоить управление автомобилем. За год он должен был стать летчиком…'
    },
  }

  export default translate;